/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { AddressAutocompleteResponse } from "../types/addressAutocompleteResponse";

import type { AddressDto } from "../types/addressDto";

import type { AutocompleteAddressParams } from "../types/autocompleteAddressParams";

import type { GetAddressDetailsParams } from "../types/getAddressDetailsParams";

import type { ProblemDetails } from "../types/problemDetails";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const autocompleteAddress = (
  params: AutocompleteAddressParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddressAutocompleteResponse>> => {
  return axios.default.get(`/api/addresses/autocomplete`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAutocompleteAddressQueryKey = (
  params?: AutocompleteAddressParams,
) => {
  return [`/api/addresses/autocomplete`, ...(params ? [params] : [])] as const;
};

export const getAutocompleteAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof autocompleteAddress>>,
  TError = AxiosError<unknown>,
>(
  params: AutocompleteAddressParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof autocompleteAddress>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAutocompleteAddressQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof autocompleteAddress>>
  > = ({ signal }) => autocompleteAddress(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof autocompleteAddress>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AutocompleteAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof autocompleteAddress>>
>;
export type AutocompleteAddressQueryError = AxiosError<unknown>;

export function useAutocompleteAddress<
  TData = Awaited<ReturnType<typeof autocompleteAddress>>,
  TError = AxiosError<unknown>,
>(
  params: AutocompleteAddressParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof autocompleteAddress>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAutocompleteAddressQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAddressDetails = (
  placeId: string,
  params?: GetAddressDetailsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddressDto>> => {
  return axios.default.get(`/api/addresses/${placeId}`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetAddressDetailsQueryKey = (
  placeId?: string,
  params?: GetAddressDetailsParams,
) => {
  return [`/api/addresses/${placeId}`, ...(params ? [params] : [])] as const;
};

export const getGetAddressDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAddressDetails>>,
  TError = AxiosError<ProblemDetails>,
>(
  placeId: string,
  params?: GetAddressDetailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAddressDetails>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAddressDetailsQueryKey(placeId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAddressDetails>>
  > = ({ signal }) =>
    getAddressDetails(placeId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!placeId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAddressDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAddressDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAddressDetails>>
>;
export type GetAddressDetailsQueryError = AxiosError<ProblemDetails>;

export function useGetAddressDetails<
  TData = Awaited<ReturnType<typeof getAddressDetails>>,
  TError = AxiosError<ProblemDetails>,
>(
  placeId: string,
  params?: GetAddressDetailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAddressDetails>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAddressDetailsQueryOptions(
    placeId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
